import { inject } from '@angular/core';
import { NativeShellService } from '@core/services/native-shell/native-shell.service';
import {
  CHAT_HEADER_MENU_ACTION,
  ChatMenuCompositionContributor,
} from 'ias-ppr-mt-chat-client';

/** Android uses the shared application setting; browser chat keeps its own entry. */
export function pwaChatNotificationMenu(): ChatMenuCompositionContributor {
  const nativeMode = inject(NativeShellService).present;
  return {
    key: 'iasppr-native-notification-settings',
    projectMenu: (context, groups) =>
      nativeMode && context.surface === 'header'
        ? groups.map((group) => ({
            ...group,
            items: group.items.filter(
              (item) =>
                item.action !== CHAT_HEADER_MENU_ACTION.systemNotifications,
            ),
          }))
        : groups,
  };
}
